export default {
  xNotify: {},
}
